import React from 'react';
import { useSystemError } from './SystemErrorContext';
import { Modal, Typography, Button, Box } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useNavigate } from 'react-router-dom';
import { removeCookie } from '../../utils/cookiesUtils';
import '../../css/error/system-error-modal.module.css';

const SystemErrorModal: React.FC = () => {
  const { systemError, clearSystemError } = useSystemError();
  const navigate = useNavigate();

  if (!systemError) return null;

  const handleLogout = () => {
    removeCookie('platform_token');
    clearSystemError();
    navigate('/auth/login');
  };

  const handleClose = () => {
    clearSystemError();
  };

  return (
    <Modal
      open={Boolean(systemError)}
      aria-labelledby="system-error-title"
      aria-describedby="system-error-description"
      BackdropProps={{
        style: { backgroundColor: 'rgba(0, 0, 0, 0.4)' }, // Lighten background
      }}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          position: 'relative',
          backgroundColor: 'white',
          boxShadow: 24,
          padding: 4,
          maxWidth: 400,
          width: '100%',
          borderRadius: '8px',
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <ErrorOutlineIcon sx={{ fontSize: 50, color: 'red', marginBottom: '16px' }} />
        <Typography id="system-error-title" variant="h6" component="h2">
          {systemError.critical ? 'Critical Error' : 'System Error'}
        </Typography>
        <Typography id="system-error-description" sx={{ mt: 2 }}>
          {systemError.error_message || 'An unexpected error occurred.'}
        </Typography>
        {systemError.critical ? (
          <Button
            onClick={handleLogout}
            variant="contained"
            sx={{
              backgroundColor: 'red',
              color: 'white',
              mt: 2,
              '&:hover': {
                backgroundColor: '#d32f2f',
              },
            }}
          >
            Close and Log Out
          </Button>
        ) : (
          <Button
            onClick={handleClose}
            variant="contained"
            sx={{
              backgroundColor: 'red', // Red color for non-critical close button
              color: 'white',
              mt: 2,
              '&:hover': {
                backgroundColor: '#d32f2f',
              },
            }}
          >
            Close
          </Button>
        )}
      </Box>
    </Modal>
  );
};

export default SystemErrorModal;
